// Reusable 4x6 Grove single-SKU pallet label (GS1-128 Pallet SSCC); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-413. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomGroveOneSkuPalletLabelFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  groveFcLocation: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  grovePoNumber: yup.string().nullable().optional(),
  grossWeight: yup.string().nullable().optional(),
  weightUom: yup.string().nullable().optional(),
  palletSequence: yup.string().nullable().optional(),
  palletCount: yup.string().nullable().optional(),
  vendorItemNumber: yup.string().nullable().optional(),
  groveSkuNumber: yup.string().nullable().optional(),
  palletSscc: yup.string().nullable().optional(),
  palletSsccBarcode: yup.string().nullable().optional(),
})

export type BiomGroveOneSkuPalletLabelFileData = yup.InferType<
  typeof biomGroveOneSkuPalletLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomGroveOneSkuPalletLabelFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomGroveOneSkuPalletLabelFileMappings: RequiredFileData = {
  customerDisplayName: 'd6ae429e-b75e-4330-bf57-37cd6e85e23c',
  shipFromAddress: 'aa21297d-ffd8-4bc0-8b48-d931eb482a0f',
  groveFcLocation: '604d94df-b83e-4891-901d-10becc9f4031',
  shipToAddress: '848264de-0b56-496b-85b4-8ba625c50aff',
  grovePoNumber: '41b4ba41-cd17-4c0f-aaeb-f2a12217a84b',
  grossWeight: 'a5b8bcbe-6944-457e-9667-ad58c17efaf9',
  weightUom: 'bed34ad7-9f93-4534-a887-33a2590ba02f',
  palletSequence: 'b28ebd58-ac7a-48a9-9b6d-129289ff2bfa',
  palletCount: '64e85df7-6bfa-460c-9374-774bc95fbbff',
  vendorItemNumber: '4fc1a762-4654-4fa9-953c-da4260abff38',
  groveSkuNumber: '0bafcfd1-dbd1-45e2-b165-2a99b8475306',
  palletSscc: 'e424ddfc-d08b-41f6-8ba0-5018bc698ceb',
  palletSsccBarcode: '9610976d-1324-4d6f-ad88-b5d558353e97',
}
